"use client";

import React from "react";
import { Sparkles, LayoutDashboard, Package, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * SolutionForAgenciesAndFreelancers — Section 5: 4 Agentur-Features
 * Drop-in für: src/pages/SolutionForAgenciesAndFreelancers/sections/AgenturFeatures.tsx
 */

const features = [{
  icon: Sparkles,
  title: "KI-Builder für jeden Kunden",
  description: "Professionelle Kunden-Websites in Minuten statt Wochen — für jede Branche, vom Coiffeur bis zum Maler."
}, {
  icon: LayoutDashboard,
  title: "Ein Dashboard, alle Kunden",
  description: "Sämtliche Kundenprojekte zentral verwalten — erstellen, bearbeiten, publizieren. Alles über ein einziges Login."
}, {
  icon: Package,
  title: "5er, 20er, 50er-Pakete",
  description: "Je mehr Kunden, desto günstiger pro Website. Custom-Pakete auf Anfrage. Whitelabel-Option ab 50 Sites."
}, {
  icon: TrendingUp,
  title: "Skalieren ohne Limits",
  description: "Ob 3 oder 300 Kunden — Hosting, SSL und Updates für jede Website inklusive. Wir wachsen mit Ihrem Business."
}];
export default function AgenturFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-6xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Warum Agenturen PAGEMAKER24 lieben
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Mehr Kunden, weniger Aufwand, höhere Marge.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {features.map((f, i) => <div key={i} className="flex items-start gap-4 bg-card border border-border rounded-xl p-5 md:p-6 hover:border-primary/40 hover:shadow-md transition-all duration-300">
              <div className="size-11 shrink-0 rounded-lg bg-primary/10 flex items-center justify-center">
                <f.icon className="size-5 text-primary" strokeWidth={2} />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-lg font-bold text-foreground mb-1.5 tracking-tight">
                  {f.title}
                </h3>
                <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                  {f.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}